export default "__VITE_ASSET__B$mtj55e__"